import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { MonitoringDelta } from './models/MonitoringDeltaModels';

export class ApiMonitoringDelta extends ApiHexaBase {
  public static override get baseUrl(): string {
    return `${ApiHexaBase.baseUrl}/monitoring_delta`;
  }

  public static async show(
    params: {
      id: string;
      page?: number;
      size?: number;
      sort_direction?: 'asc' | 'desc';
    }) {
    const response = await ApiBase.get(this.baseUrl, params);

    return response.data.data as {
      delta: Record<string, Record<string, any>>;
      total: number;
    };
  }
}
